export const formatMonto = (value) => {
    const amount = Number(value)
    if (!Number.isFinite(amount)) {
        return '0.00'
    }
    return amount.toFixed(2)
}
